import request from '@/utils/request'
/***************综合信息查询*****************/
// 获取省份
export function getCityTree(params) {
  return request({
    url: `/chzz-area/tree`,
    method: "post",
    params
  });
}

export default {
  getCityTree,
}
